import { employeeTaggingAdapter } from './employeeTaggingAdapter'
import { EntityTaggingProvider } from './EntityTaggingProvider'
import type { TaggingProviderProps } from './TaggingProvider.types'

export const EmployeeTaggingProvider = (props: TaggingProviderProps) => (
  <EntityTaggingProvider {...props} adapter={employeeTaggingAdapter} />
)
